import IDynamicFormRow from '../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow';
import { ICurrency } from '../yoello-lib/modules/redux/actions/localization';
import FormSwitchWithText from '../yoello-lib/modules/dynamicForms/FormComponents/FormSwitchWithText';
import FormTextBox from '../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox';
import { FormPriceFieldTextAlongside } from '../yoello-lib/modules/dynamicForms/CustomFormComponents/FormPriceFieldText';
import FormSmallTextBox from '../yoello-lib/modules/dynamicForms/FormComponents/FormSmallTextBox';

export function visiblityForm(disabled?: boolean): IDynamicFormRow[] {
  return [
    {
      label: 'forms.mysettings.enabled',
      Component: FormSwitchWithText,
      keyName: 'enabled',
      disabled: disabled,
      formProps: { secondLabel: 'forms.mysettings.enabledinfo', hasStatus: true },
    },
    // {
    //     label: "forms.mysettings.visible", type: "switchWithText", keyName: "visible",
    //     formElement: { formProps: { secondLabel: "forms.mysettings.visibleinfo" } }

    // }
  ];
}
export function reviewsForm(): IDynamicFormRow[] {
  return [
    {
      label: 'forms.mysettings.reviewsEnabled',
      Component: FormSwitchWithText,
      keyName: 'reviews_enabled',
      disabled: false,
      formProps: { secondLabel: 'forms.mysettings.reviewsToggleInfo', hasStatus: true },
    },
  ];
}
export function vatForm(): IDynamicFormRow[] {
  return [
    {
      label: 'forms.mysettings.vatreg',
      Component: FormSwitchWithText,
      keyName: 'venue_vat_reg',
      formProps: { secondLabel: 'forms.mysettings.vatreginfo' },
      gridColumnOptions: {
        formCol: 6,
      },
    },
    {
      label: 'forms.mysettings.vatregno',
      keyName: 'venue_vat_reg_no',
      Component: FormTextBox,
      gridColumnOptions: {
        formCol: 6,
      },
    },
  ];
}
export const feesForm = (
  currency: ICurrency | undefined
): IDynamicFormRow[] => {
  return [
    {
      label: 'forms.mysettings.serviceCharge.fixedLabel' + currency?.iso_code,
      keyName: 'service_charge_pence_amount',
      Component: FormPriceFieldTextAlongside,
      formProps: {
        displaySymbol: true,
        sideLabel:
          'forms.mysettings.serviceCharge.fixedTitle' + currency?.iso_code,
        secondLabel: 'forms.mysettings.serviceCharge.fixedDescription',
      },
    },
    {
      label: 'forms.mysettings.serviceCharge.percentageLabel',
      keyName: 'service_charge_percentage_amount',
      Component: FormSmallTextBox,
      formProps: {
        sideLabel: 'forms.mysettings.serviceCharge.percentageTitle',
        secondLabel: 'forms.mysettings.serviceCharge.percentageDescription',
      },
      inputProperties: {
        type: 'number',
        inputProps: {
          min: 0,
          max: 100,
          step: 0.01,
        },
      },
      registerOptions: {
        min: 0,
        max: 100,
      },
    },
  ];
};
